import { Grid, InputLabel, Checkbox as MuiCheckbox } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CheckboxWithError = styled(MuiCheckbox)(({ error }) => ({
  boxShadow: error ? "0px 0px 3px 1px #f44336, inset 0 0 0 1px #f44336" : "",
}));

export const Checkbox = styled(MuiCheckbox)({
  padding: "2px",
  marginRight: "6px",
});

const PREFIX = "input-wrapper";

export const classes = {
  label: `${PREFIX}-label`,
};

export const LabelStyled = styled(InputLabel, {
  shouldForwardProp: (prop) => prop !== "marginRight" && prop !== "marginLeft",
})(({ error, marginRight, marginLeft, theme }) => ({
  color: error ? theme?.palette?.danger[600] : theme?.palette?.black.main,
  fontFamily: "Source Sans Pro",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "18px",
  marginRight: marginRight ? marginRight : "10%",
  marginLeft: marginLeft ? marginLeft : "10px",
}));

export const InputWrapper = styled(Grid)(({ theme }) => ({
  position: "relative",
  display: "flex",
  flex: 1,
  "& > div": {
    "& input": {
      color: theme?.palette?.black[650],
    },
  },

  [`& .${classes.label}`]: {
    display: "flex",
    alignItems: "center",
    width: "calc((100% / 12) * 4)",
    margin: 0,
    paddingRight: "10%",
    paddingLeft: "10px",
    boxSizing: "border-box",
  },
}));
